<div class="row" *ngIf="!addNew">
  <div class="col-md-3">
    <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
      <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
        <input class="inputTxt" placeholder="{{ 'search' | translate }}" maxlength="100" #searchVal
               (change)='checkSearchVal(searchVal.value)' (keyup)="checkSearchVal(searchVal.value)"
               (keyup.enter)="checkSearchVal(searchVal.value)"/>
        <i-tabler name="search" class="icon-20 d-flex icon m-l-6 m-t-6"></i-tabler>
        <i-tabler name="plus" class="icon-20 d-flex icon m-l-6 m-t-6" *ngIf="showAdd" (click)="ShowOrder(null)"></i-tabler>
      </mat-card-header>
      <div class="col-md-12">
        <app-slicemenu [DataList]="orders" [selected]="selectedOrder" [columns]="['date', 'supplierName']"
                       [columnName]="'categoryName'" (newItemEvent)="ShowOrder($event)"></app-slicemenu>
      </div>
    </mat-card>
  </div>

  <div class="col-md-9">
    <div class="divCreate">
      <a class="btnCreate btn-icon-group" (click)="ShowOrder(null)" *ngIf="showAdd" >
        <i-tabler name="plus" class="icon-15 btn-icon"></i-tabler>
        {{ 'CreateNewOrder' | translate}}
      </a>
    </div>
    <app-invoice *ngIf="!addNew && selectedOrderData" [BuySellOrderData]="selectedOrderData"
                 [showClose]="false"></app-invoice>
  </div>
</div>
<div *ngIf="addNew">
  <div class="divCreate">
    <button mat-button class="btnClose" (click)="Back()" >
      {{ 'Back' | translate}}
    </button>
  </div>
  <app-buy-order></app-buy-order>
</div>
